/**
 * 文件说明:
 *
 * crm utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import numeral from 'numeral'
import dayjs from 'dayjs'
import constants from 'crm/common/constants'

const {dateTimeFormat} = constants

export function forEachParents(item, cb, parentName = 'parent') {
    while (item[parentName]) {
        cb(item[parentName])
        item = item[parentName]
    }
}

export function canvasToDataUrl(video) {
    const canvas = document.createElement('canvas')
    canvas.height = video.videoHeight * 0.5
    canvas.width = video.videoWidth * 0.5
    const ctx = canvas.getContext('2d')
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
    return canvas.toDataURL('image/jpeg', 0.35)
}

export function addNoReferrerMeta() {
    // 添加<meta name="referrer" content="no-referrer">，为了微信图片能正常显示
    const metas = document.getElementsByTagName('meta')
    const referrerMeta = metas.referrer || document.createElement('meta')
    referrerMeta.name = 'referrer'
    referrerMeta.content = 'no-referrer'
    const viewportMeta = metas.viewport
    document.getElementsByTagName('head')[0].insertBefore(referrerMeta, viewportMeta)
}
export function resetReferrerMeta() {
    // 修改meta referrer为默认值
    const referrerMeta = document.getElementsByTagName('meta').referrer
    referrerMeta.setAttribute('content', 'no-referrer-when-downgrade')
}

export function removeUrlParameter(url, key) {
    if (url && key) {
        const reg = new RegExp(`(\\?|&)${key}=[^&]*(&)?`, 'g')
        return url.replace(reg, ($0, $1, $2) => {
            if ($1 === '?') {
                return $2 ? $1 : ''
            }
            return $2 || ''
        })
    }
    return url
}

/**
 * canvas获取视频封面
 */
export function genVideoCover(url, callback, second = 1) {
    const video = document.createElement('video')
    video.setAttribute('crossorigin', 'anonymous')
    // 取视频第n秒
    video.addEventListener('loadeddata', function () {
        this.currentTime = second
    })
    video.addEventListener('seeked', () => {
        const imageUrl = canvasToDataUrl(video)
        callback && callback(imageUrl)
    })
    video.addEventListener('error', () => {
        callback && callback()
    })
    video.src = url
}

/**
 * 获取url所有参数
 * @param url
 * @returns {{}}
 */
export function getUrlParameters(url) {
    if (!url || typeof url !== 'string') {
        url = window.location.href
    }
    url = decodeURIComponent(url)
    const search = url.match(/([^?=&]+)(=([^&]*))/g)
    if (search) {
        return search.reduce((obj, item) => {
            const equalSignIndex = item.indexOf('=')
            const key = item.slice(0, equalSignIndex)
            const value = item.slice(equalSignIndex + 1)
            obj[key] = value
            return obj
        }, {})
    }
}

export function getCount(count, defaultCount = 0) {
    if (typeof count === 'number') {
        return count
    }
    if (typeof count === 'string') {
        const num = Number(count)
        return Number.isNaN(num) ? defaultCount : num
    }
    return defaultCount
}

export function getPercent(rate, format = '0[.]00%') {
    const count = getCount(rate)
    return numeral(count).format(format)
}

function findParents(data, id, parents) {
    for (let i = 0; i < data.length; i++) {
        const item = data[i]
        if (item?.id === id) {
            parents.push(item)
            return parents
        }
        if (!item?.children?.length) {
            continue
        }
        parents.push(item)
        const result = findParents(item?.children, id, parents)
        if (result.length) {
            return parents
        }
        parents.pop()
    }
    return []
}

export function getParents(id, data) {
    return findParents(data, id, [])
}

export function formatTimestamp(timestamp, defaultContent = '--') {
    return timestamp ? dayjs(timestamp * 1000).format(dateTimeFormat) : defaultContent
}
